(() => {
  angular
    .module('complianceFrameworkApp.complianceForums')
    .directive('forumsSearch', forumsSearch);

  /* ngInject */
  function forumsSearch($state) {
    let directive = {
      restrict: 'E',
      templateUrl: '/templates/compliance_forums/components/forums-search.directive.html',
      link: link
    };

    return directive;

    function link(scope, _element, _attrs) {
      scope.search = search;
    }

    function search() {
      let query = angular.element('#search-query').val();
      $state.go('application.compliance_forums.search', { query: query });
    }
  }
})();
